// extracted by mini-css-extract-plugin
export default {"LinkTextIndex":"IndexNavbarItem_LinkTextIndex__OFT-q","IndexText":"IndexNavbarItem_IndexText__UcPjf","CurrentLocation":"IndexNavbarItem_CurrentLocation__FsSvX"};